module.exports = __webpack_public_path__ + "514dbc34513b1a1be34087eda9b63245.pdf";